magna.athletesCarousel = parent => {
  const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
    let dotNodes = []

    const addDotBtnsWithClickHandlers = () => {
      dotsNode.innerHTML = emblaApi
        .scrollSnapList()
        .map(() => '<button class="slideshow__dot" type="button"></button>')
        .join('')

      const scrollTo = index => {
        emblaApi.scrollTo(index)
      }

      dotNodes = Array.from(dotsNode.querySelectorAll('.slideshow__dot'))
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener('click', () => scrollTo(index), false)
      })
    }

    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap()
      const selected = emblaApi.selectedScrollSnap()
      dotNodes[previous]?.classList?.remove('slideshow__dot--selected')
      dotNodes[selected]?.classList?.add('slideshow__dot--selected')
    }

    emblaApi
      .on('init', addDotBtnsWithClickHandlers)
      .on('reInit', addDotBtnsWithClickHandlers)
      .on('init', toggleDotBtnsActive)
      .on('reInit', toggleDotBtnsActive)
      .on('select', toggleDotBtnsActive)

    return () => {
      dotsNode.innerHTML = ''
    }
  }

  const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => {
      emblaApi.scrollPrev()
      emblaApi.reInit()
    }
    const scrollNext = () => {
      emblaApi.scrollNext()
      emblaApi.reInit()
    }
    prevBtn?.addEventListener('click', scrollPrev, false)
    nextBtn?.addEventListener('click', scrollNext, false)

    return () => {
      prevBtn?.removeEventListener('click', scrollPrev, false)
      nextBtn?.removeEventListener('click', scrollNext, false)
    }
  }

  const OPTIONS = { loop: false }

  const viewportNode = parent.querySelector('.slideshow--athletes')
  const dotsNode = parent.querySelector('.slideshow__dots-container')
  const prevBtnNode = parent.querySelector('.button--prev')
  const nextBtnNode = parent.querySelector('.button--next')

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
    EmblaCarouselAutoplay({ playOnInit: true, delay: 3000, stopOnInteraction: false }),
  ])

  addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode)
  addDotBtnsAndClickHandlers(emblaApi, dotsNode)
}

magna.alternatingSlider = parent => {
  console.log('parent', parent)
  const OPTIONS = { 
    loop: false,
    align: 'start'
  }

  const emblaNode = parent
  const viewportNode = emblaNode.querySelector('.alternating-slider__slider-container')

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

  return emblaApi
}

magna.announcementBar = parent => {
  const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => {
      emblaApi.reInit()
      emblaApi.scrollPrev()
    }
    const scrollNext = () => {
      emblaApi.reInit()
      emblaApi.scrollNext()
    }
    prevBtn?.addEventListener('click', scrollPrev, false)
    nextBtn?.addEventListener('click', scrollNext, false)

    return () => {
      prevBtn?.removeEventListener('click', scrollPrev, false)
      nextBtn?.removeEventListener('click', scrollNext, false)
    }
  }

  const OPTIONS = { loop: true }

  const viewportNode = parent.querySelector('.announcement-bar__section')
  const prevBtnNode = parent.querySelector('.button--prev')
  const nextBtnNode = parent.querySelector('.button--next')

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
    EmblaCarouselAutoplay({ playOnInit: true, delay: 5000, stopOnInteraction: true }),
  ])

  addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode)
}



magna.doctorsCarousel = () => {
  const OPTIONS = { loop: false }

  const emblaNode = document.querySelector('.doctors')
  const viewportNode = emblaNode.querySelector('.slideshow--doctors')

  EmblaCarousel(viewportNode, OPTIONS)
}

magna.ugcCarousel = () => {
  const OPTIONS = { loop: false }

  const emblaNode = document.querySelector('.ugc')
  const viewportNode = emblaNode.querySelector('.slideshow--athletes')

  EmblaCarousel(viewportNode, OPTIONS, [EmblaCarouselAutoplay({ playOnInit: true, delay: 3000, stopOnInteraction: false })])
}

magna.productCarousel = {}

magna.buyCarousel = (item) => {
  const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
    let dotNodes = []

    const addDotBtnsWithClickHandlers = () => {
      dotsNode.innerHTML = emblaApi
        .scrollSnapList()
        .map(() => '<button class="buy__dot" type="button"></button>')
        .join('')

      const scrollTo = index => {
        emblaApi.scrollTo(index)
      }

      dotNodes = Array.from(dotsNode.querySelectorAll('.buy__dot'))
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener('click', () => scrollTo(index), false)
      })
    }

    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap()
      const selected = emblaApi.selectedScrollSnap()
      dotNodes[previous]?.classList?.remove('buy__dot--selected')
      dotNodes[selected]?.classList?.add('buy__dot--selected')
    }

    emblaApi
      .on('init', addDotBtnsWithClickHandlers)
      .on('reInit', addDotBtnsWithClickHandlers)
      .on('init', toggleDotBtnsActive)
      .on('reInit', toggleDotBtnsActive)
      .on('select', toggleDotBtnsActive)

    return () => {
      dotsNode.innerHTML = ''
    }
  }

  const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => {
      emblaApi.scrollPrev()
    }
    const scrollNext = () => {
      emblaApi.scrollNext()
    }
    prevBtn?.addEventListener('click', scrollPrev, false)
    nextBtn?.addEventListener('click', scrollNext, false)

    return () => {
      prevBtn?.removeEventListener('click', scrollPrev, false)
      nextBtn?.removeEventListener('click', scrollNext, false)
    }
  }

  const OPTIONS = { loop: true, spacing: 10 }

  const viewportNode = item
  const prevBtnNode = item.querySelector('.button--prev')
  const nextBtnNode = item.querySelector('.button--next')
  const dotsNode = item.querySelector('.buy__dots')

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

  addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode)
  addDotBtnsAndClickHandlers(emblaApi, dotsNode)
  magna.productCarousel = emblaApi
}

magna.drawerRecommendedCarousel = () => {
  return; // disabled for now
  const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
    let dotNodes = []

    const addDotBtnsWithClickHandlers = () => {

      dotsNode.innerHTML = emblaApi
        .scrollSnapList()
        .map(() => '<button class="drawer__recommended-products-dot" type="button"></button>')
        .join('')

      const scrollTo = index => {
        emblaApi.scrollTo(index)
      }

      dotNodes = Array.from(dotsNode.querySelectorAll('.drawer__recommended-products-dot'))
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener('click', () => scrollTo(index), false)
      })
    }

    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap()
      const selected = emblaApi.selectedScrollSnap()
      dotNodes[previous]?.classList?.remove('drawer__recommended-products-dot--selected')
      dotNodes[selected]?.classList?.add('drawer__recommended-products-dot--selected')
    }

    emblaApi
      .on('init', addDotBtnsWithClickHandlers)
      .on('reInit', addDotBtnsWithClickHandlers)
      .on('init', toggleDotBtnsActive)
      .on('reInit', toggleDotBtnsActive)
      .on('select', toggleDotBtnsActive)

    return () => {
      dotsNode.innerHTML = ''
    }
  }

  const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => {
      emblaApi.scrollPrev()
    }
    const scrollNext = () => {
      emblaApi.scrollNext()
    }
    prevBtn?.addEventListener('click', scrollPrev, false)
    nextBtn?.addEventListener('click', scrollNext, false)

    return () => {
      prevBtn?.removeEventListener('click', scrollPrev, false)
      nextBtn?.removeEventListener('click', scrollNext, false)
    }
  }

  const OPTIONS = { loop: false }

  const emblaNode = document.querySelector('.CartDrawer-recommended-products')
  const viewportNode = emblaNode.querySelector('.drawer__recommended-products')
  const prevBtnNode = emblaNode.querySelector('.drawer__recommended-products-button--prev')
  const nextBtnNode = emblaNode.querySelector('.drawer__recommended-products-button--next')
  const dotsNode = emblaNode.querySelector('.drawer__recommended-products-dots')

  if (!dotsNode) return

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

  addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode)
  addDotBtnsAndClickHandlers(emblaApi, dotsNode)
}

